// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2l4Dj","subheader":"ReorderModal_subheader__3bspM","listWrap":"ReorderModal_listWrap__3ZZWZ"};